import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = 'https://fakestoreapi.com/'

export const productApi = createApi({
  reducerPath: 'products',
  baseQuery: fetchBaseQuery({baseUrl}),
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: () => `products/`,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProductsQuery } = productApi;